<div class="class-info-main" *ngIf="classDetail">
  <section class="class-info__image" *ngIf="classDetail.bannerImage"
    [style.background-image]="'url('+ imageUrl +')'">
  </section>
  <section class="class-info__detail" [ngClass]="{'mt-20':classDetail.bannerImage === ''}">
    <div class="class-info__detail--header">
      <div class="class-info__detail--header-left">
        <h1 class="class-info__detail__name">{{classDetail.LessonName}}</h1>
        <div class="class-info__detail__location">
          <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on</mat-icon>
          &nbsp;{{classDetail.LocationName}}
        </div>
      </div>
      <div class="class-info__detail--header-right" *ngIf="classDetail.BaseRate">
        <label for="rate" class="class-info__detail__rate-label">{{'Startingfrom' | translate}}</label>
        <div class="class-info__detail__rate-value">{{operatingCurrency}} {{classDetail.BaseRate | currencyDecimalFormatter}}
        </div>
      </div>
    </div>
    <div class="class-info__detail--content">
      <div class="class-info__detail__item">
        <label for="activity-type" class="class-info__detail__item--label">{{'activityType' | translate}}</label>
        <div class="class-info__detail__item--value">{{classDetail.activityType}}</div>
      </div>
      <div class="class-info__detail__item">
        <label for="start-date" class="class-info__detail__item--label">{{'startDate' | translate}}</label>
        <div class="class-info__detail__item--value">{{classDetail.StartDate | localizeDate : 'L'}}</div>
      </div>
      <div class="class-info__detail__item">
        <label for="endDate" class="class-info__detail__item--label">{{'endDate' | translate}}</label>
        <div class="class-info__detail__item--value">{{classDetail.EndDate | localizeDate : 'L'}}</div>
      </div>
      <div class="class-info__detail__item"*ngIf="showAvailableSlotCount">
        <label for="available" class="class-info__detail__item--label">{{'availableSlots' | translate}}</label>
        <i *ngIf="classDetail.ClassType === ClassType.Session" class="icon-Info class-info__detail__slotInfo"  matTooltipPosition="above"  matTooltip="{{ 'sessionSlotCountInfoMessage' | translate}}"></i>
        <div class="class-info__detail__item--value class-info__detail__item__value-avilable">
          {{classDetail.AvailableSlots}}
        </div>
      </div>
      <div class="class-info__detail__item class-info__detail__item_last">
        <label for="instructor" class="class-info__detail__item--label">{{'Instructor' | translate}}</label>
        <div class="class-info__detail__item--value class-info__ellipsis" title="{{classDetail.Staffs}}">
          {{classDetail.Staffs}}</div>
      </div>
    </div>
    <div *ngIf="!showAvailableSlotCount || classDetail.AvailableSlots == 0" class="class-info__detail__note">{{'checkAvailabilityOtherDays' |
      translate}}</div>
    <div class="class-info__detail--footer">
      <app-button [buttontype]="backButton" (valueChange)="backClick($event)">
      </app-button>
      <app-button [buttontype]="bookButton" (valueChange)="bookClick($event)">
      </app-button>
    </div>
  </section>
  <section class="class-info__description" *ngIf="classDetail.Description">
    <h2 class="heading-secondary" >
      {{'sescription' | translate}}
    </h2>
    <p class="class-info__description-text" [ngClass]="classDetail.Description && classDetail.Description.length > 150 ? 'text-justify' : 'text-center' ">
      {{classDetail.Description | textCutter: (descriptionReadMoreClicked ? null : textMaxLegth)}} {{classDetail.Description.length}}
      <span class="class-info__read-more" *ngIf="classDetail.Description.length > textMaxLegth"
        (click)="descriptionReadMoreClicked = !descriptionReadMoreClicked">
        {{descriptionReadMoreClicked ? ('readLess' | translate) : ('readMore' | translate)}}
      </span>
    </p>
  </section>
  <section class="class-info__description" *ngIf="classDetail.safetyInformation">
    <h2 class="heading-secondary">
      {{'safetyInformation' | translate}}
    </h2>
    <p class="class-info__description-text">
      {{classDetail.safetyInformation | textCutter: (safetyInformationReadMoreClicked ? null : textMaxLegth)}}
      <span class="class-info__read-more" *ngIf="classDetail.safetyInformation.length > textMaxLegth"
        (click)="safetyInformationReadMoreClicked = !safetyInformationReadMoreClicked">
        {{safetyInformationReadMoreClicked ? ('readLess' | translate) : ('readMore' | translate)}}
      </span>
    </p>
  </section>
</div>